export const setThemeFromVariant = (
  propsTheme?: 'dark' | 'light',
  propsVariant?: string
): 'dark' | 'light' | undefined => {
  let theme: 'dark' | 'light' | undefined = 'light';

  if (propsTheme) {
    theme = propsTheme;
  } else if (propsVariant) {
    theme = propsVariant === 'dark' ? 'dark' : 'light';
  }

  return theme;
};

export const setButtonTypeFromVariant = (
  propsButtonType?: string,
  propsVariant?: string
): string => {
  let buttonType = 'primary';

  if (propsButtonType) {
    buttonType = propsButtonType;
  } else {
    buttonType = propsVariant === 'dark' ? 'outlined' : 'primary';
  }

  return buttonType;
};
